import { createPopper } from '@popperjs/core'

export default () => {
    let popper
    let panel
    let closeTimer

    return {
        open: false,
        instant: false,
        mount(element) {
            panel = element
        },
        show(event) {
            clearTimeout(closeTimer)
            this.instant = event?.type === 'focus'
                ? this.$refs.trigger.matches(':focus-visible')
                : event?.type === 'mouseenter'
                    ? !window.matchMedia('(hover: hover) and (pointer: fine)').matches
                    : event?.detail === 0
            this.open = true
            this.$nextTick(() => {
                if (!this.open || !panel) return
                popper ??= createPopper(this.$refs.trigger, panel, {
                    placement: 'top',
                    strategy: 'fixed',
                    modifiers: [
                        { name: 'offset', options: { offset: [0, 8] } },
                        { name: 'preventOverflow', options: { padding: 16 } },
                    ],
                })
                popper.update()
            })
        },
        hide(event) {
            clearTimeout(closeTimer)
            if (event?.type === 'keydown' || event?.type === 'blur') this.instant = true
            this.open = false
        },
        leave() {
            closeTimer = setTimeout(() => {
                if (document.activeElement !== this.$refs.trigger) this.hide()
            }, 150)
        },
        destroy() {
            clearTimeout(closeTimer)
            popper?.destroy()
            panel = null
        },
    }
}
